import { render, staticRenderFns } from "./IconHeartSolid.vue?vue&type=template&id=7b60bcd2"
import script from "./IconHeartSolid.vue?vue&type=script&lang=js"
export * from "./IconHeartSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports